import IconButton from "components/atoms/button/IconButton";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import Form from "components/atoms/form/Form";
import Icon from "components/atoms/icon/Icon";
import Input from "components/atoms/input/Input";
import Label from "components/atoms/input/input-label/InputLabel";
import TextArea from "components/atoms/text-area/TextArea";
import PrimaryDatePicker from "components/molecules/datepicker/PrimaryDatePicker";
import InputsFolder from "components/molecules/inputs-folder/InputsFolder";
import { IconType } from "lib/helpers/constants/iconTypes";
import React, { Dispatch, FC, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ChooseProducts from "./choose-products/ChooseProducts";
import { usePartners } from "lib/hooks/queries/Partners/usePartnersForFilter";
import Checkbox from "components/atoms/checkbox/Checkbox";
import { useCustomerForm } from "lib/hooks/forms/useCustomerForm";
import withModal from "lib/helpers/hoc/withModal";
import { useCreateCustomer } from "lib/hooks/mutations/Customers/useCreateCustomer";
import { useUsersByPermission } from "lib/hooks/mutations/UsersByPermission/useUsersByPermission";
import { usePermissions } from "lib/hooks/shared/usePermissions";
import { toast } from "react-toastify";
import RelatedCustomerForm from "./related-customer-form/RelatedCustomerForm";
import Button from "components/atoms/button/Button";
import { customStyles } from "lib/helpers/configs/customStyles";
import { languageData } from "lib/helpers/constants/languageData";
import Creatable from "react-select/creatable";
import { numbersCode } from "lib/helpers/constants/numbersCode";
import Flag from "react-world-flags";
import { useTranslation } from "react-i18next";
import { usePartnerSingleProduct } from "lib/hooks/queries/Partners/usePartnerSingleProduct";
import RadioButton from "components/atoms/radio-button/RadioButton";
import { nationalities } from "lib/helpers/constants/nationalities";
import AutoCompletInput from "components/atoms/input/autocomplet-input/AutoCompletInput";
import { useRegions } from "lib/hooks/queries/User/useRegions";
import AddNewField from "./add-new-field/AddNewField";
import CounterControl from "components/molecules/counter-control-append/CounterControlAppend";

export interface IProps {
  onConfirm: () => void;
  setCurrentFormStep: Dispatch<number>;
  currentStep: number;
  themeColors: {
    primary: string;
  };
  isCompany: boolean;
}

const CreateCustomerProcces: FC<IProps> = ({
  onConfirm,
  setCurrentFormStep,
  currentStep,
  themeColors,
  isCompany
}) => {
  const [activeTab, setActiveTab] = useState<number>(1);

  const { data: partnersData } = usePartners();
  const { t } = useTranslation();
  const [formData, setFormData] = useState<any>({
    art_of_application: 'Online Application',
    mandated: 1
  });
  const { mutateAsync: create } = useCreateCustomer();
  const { mutateAsync: getUsersByPermission } = useUsersByPermission();
  const [fetchedUsers, setFetchedUsers] = useState<Array<string>>([]);
  const hasPermissionToAssign = usePermissions(['assign_customers_assign']);
  // const hasPermissionToEditRelationship = usePermissions(['manage_customers_relationship_edit']);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useCustomerForm({
    defaultValues: {
      city: '',
      postal_code: '',
      number_of_employees: 1,
    }
  });

  const defaultValue = numbersCode.find(item => item.value === '+41');

  const { handleSubmit: handleSubmitExtraField } = useForm();

  const defaultOptions = [
    {
      id: 0,
      checkboxValue: 'KVG',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 1,
      checkboxValue: 'VVG',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 2,
      checkboxValue: 'Life',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 3,
      checkboxValue: 'Lawprotection',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 4,
      checkboxValue: 'Business',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 5,
      checkboxValue: 'Auto',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    },
    {
      id: 6,
      checkboxValue: 'Company',
      customOptions: partnersData?.partners?.map?.((partner: any) => ({
        label: partner?.name,
        value: partner?.name,
        id: partner?.id,
      })),
    }
  ]

  const [optionsByCheckbox, setOptionsByCheckbox] = useState<any>(defaultOptions);

  useLayoutEffect(() => {
    if (partnersData) {

      setOptionsByCheckbox(defaultOptions);
    }

    //eslint-disable-next-line
  }, [partnersData]);



  const [PartnerParams, setPartnerParams] = useState<any>({ base_product: null, partner_id: null });

  const { data: partnerProductsData, isLoading } = usePartnerSingleProduct(PartnerParams);

  const [PartnerProductsState, setPartnerProductsState] = useState<Record<string, any>>({});


  useEffect(() => {
    if (partnerProductsData && PartnerParams.base_product) {
      setPartnerProductsState((prev) => ({
        ...prev,
        [PartnerParams.base_product]: partnerProductsData
      }));
    }
  }, [partnerProductsData, PartnerParams.base_product]);

  const [LastChangedSelectId, setLastChangedSelectId] = useState(null);

  useEffect(() => {
    if (PartnerParams.base_product) {
      setValue(`product.${LastChangedSelectId}`, null);

    }
    if (LastChangedSelectId) {
      handleProductChange(LastChangedSelectId, null);
    }
    // eslint-disable-next-line
  }, [partnerProductsData]);

  const addNewOption = (checkboxValue: string) => {
    setOptionsByCheckbox((prevOptions: any) => {
      // Find the index of the option that matches the checkboxValue
      const index = prevOptions.findIndex((option: any) => option.checkboxValue === checkboxValue);

      if (index !== -1) {
        // Create the new option with an updated ID and custom options
        const newOption = {
          ...prevOptions[index],
          id: prevOptions.length, // Assign a new unique ID
          customOptions: prevOptions[index].customOptions || [], // Ensure it's an array
        };

        // Insert the new option directly after the found option
        const updatedOptions = [
          ...prevOptions.slice(0, index + 1), // Keep everything before the matched option
          newOption, // Add the new option
          ...prevOptions.slice(index + 1), // Keep everything after the matched option
        ];

        return updatedOptions;
      }

      // If the checkboxValue isn't found, return the original options without changes
      return prevOptions;
    });
  };

  const removeOption = (id: number) => {
    setOptionsByCheckbox((prevOptions: any) => {
      // Filter out the option with the matching ID
      const updatedOptions = prevOptions.filter((option: any) => option.id !== id);


      return updatedOptions;
    });

    setFormData((prevFormData: any) => {
      const updatedFormData = { ...prevFormData };

      delete updatedFormData[id];

      return updatedFormData;
    })
  }

  useEffect(() => {
    getUsersByPermission({
      permissions: ['customers_view_view', 'customers_view_view_own'],
    })
      .then((res) => {
        setFetchedUsers(res.users);
      })
      .catch(() => { });
    // eslint-disable-next-line
  }, []);

  const handleCheckboxChange = (checkboxValue: string, checked: boolean) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [checkboxValue]: {
        checked: checked,
        selected: checked ? prevFormData[checkboxValue]?.selected || "" : "",
      },
    }));

  };
  const [relatedCustomers, setRelatedCustomers] = useState<any[]>([]);

  const handleSelectChange = (checkboxValue: string, selected: string) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [checkboxValue]: {
        ...prevFormData[checkboxValue],
        selected: selected,
      },
    }));

  };
  const handleProductChange = (checkboxValue: string, selected: string | null) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [checkboxValue]: {
        ...prevFormData[checkboxValue],
        product_name: selected,
      },
    }));

  };

  const formatOptionLabel = (data: any, { context }: any) => {
    if (context === "menu") {
      return (
        <div className="flex items-center">
          <Flag code={data.icon} height={14} width={14} />
          <span className="ml-2">{data.label}</span>
        </div>
      );
    } else {
      return (
        <div className="text-center mx-auto">
          {data.label}
        </div>
      )
    }
  };
  const [onSubmitFormData, setOnSubmiFormData] = useState<any>([]);
  const [productsFormData, setProductsFormData] = useState<any>([]);

  const [IsAddNewFieldModalOpen, setIsAddNewFieldModalOpen] = useState(false)

  let extraFields: { [key: string]: any } = {};

  const [state, setState] = useState<any>([]);

  const onSubmit = (data: Record<string, any>) => {
    const combinedPhoneNumber = `${data.code} ${data.phone}`;
    const combinedCompanyPhoneNumber = `${data.company_phone_code} ${data.company_phone}`;

    // eslint-disable-next-line
    state.map((item: any) => {
      extraFields[item?.data?.field_name] = {
        value: watch(item?.data?.field_name),
        default_text: item?.data?.default_text,
        required: item?.data?.required ? 1 : 0,
        section: item?.data?.section,
        field_type: item?.data?.field_type,
      };
    });
    const extraFieldNames = Object.keys(extraFields);

    // Destructure these fields out of data
    let dataWithoutExtraFields = { ...data };
    extraFieldNames.forEach((fieldName) => {
      delete dataWithoutExtraFields[fieldName];
    });

    const extraFieldsArray = Object.keys(extraFields).map((key) => ({
      section: extraFields[key].section,
      field_name: key,
      field_value: extraFields[key].value,
      default_text: extraFields[key].default_text,
      required: extraFields[key].required,
      field_type: extraFields[key].field_type,
    }));

    const combinedData = {
      ...dataWithoutExtraFields,
      phone: combinedPhoneNumber,
      is_type_company: isCompany,
      company_phone_number: combinedCompanyPhoneNumber,
      mandated: formData.mandated,
      art_of_application: formData.art_of_application,
      products: formData.products,
      costumer_relations_id: relatedCustomers?.[0]?.id || null,
      extra_fields: extraFieldsArray,
    };


    setOnSubmiFormData(combinedData);
    setCurrentFormStep(2);

  };

  const onSubmitExtraFields = async (data: any) => {

    const selectedProducts = Object.keys(formData)
      .filter((key) => formData[key].checked)
      .map((key) => ({
        name_of_products: optionsByCheckbox.filter((option: any) => option.id === parseInt(key))[0].checkboxValue,
        company_of_product: formData[key].selected,
        product_name: formData[key].product_name,
      }));

    const existingProducts = formData.products || [];

    const hasDuplicates = selectedProducts.some((selectedProduct) =>
      existingProducts.some(
        (existingProduct: any) =>
          existingProduct.name_of_products === selectedProduct.name_of_products
      )
    );

    if (hasDuplicates) {
      toast.error(t('Duplicate products are not allowed'));
      return;
    }




    const combinedData = {
      ...data,
      mandated: formData.mandated,
      art_of_application: formData.art_of_application,
      products: [...existingProducts, ...selectedProducts],
    };

    setFormData(combinedData);

    setProductsFormData({
      mandated: formData.mandated,
      art_of_application: formData.art_of_application,
      products: combinedData.products,
    });

    const resetFormData = Object.keys(formData).reduce((acc: any, key) => {
      acc[key] = { checked: false, selected: "" };
      return acc;
    }, {});

    setFormData({
      ...resetFormData,
      products: combinedData.products,
    });


    setCurrentFormStep(1);
    setActiveTab(2);
  };

  const handleAddCustomer = (customer: any) => {
    setRelatedCustomers([
      { id: customer.id, name: `${customer.first_name} ${customer.last_name}` },
    ]);
  };

  const { data: regionsData } = useRegions()

  const flatData = useMemo(() => {

    if (!regionsData) return []

    return (regionsData as any)?.data.map((item: { plz: any; ort: any; commune: any; }) => `${item.plz}, ${item.ort}, ${item.commune ?? ''}`);

  }, [regionsData])


  const [LocationValue, setLocationValue] = useState('');


  useEffect(() => {

    if (LocationValue !== '') {

      const SplitLocation = LocationValue?.split(',')

      setValue("postal_code", SplitLocation[0]?.trim());

      if (SplitLocation[1]?.trim()) {
        setValue("city", SplitLocation[1]?.trim() + (SplitLocation[2] ? `,${SplitLocation[2]}` : ''));
      }
    }

  }, [LocationValue, setValue])




  return (
    <div>
      <ConditionalRender condition={currentStep === 1}>
        <div className="flex flex-col lg:flex-row gap-10  !md:min-w-auto md-max-w-[750px] lg:max-w-[1200px]">
          {/* <div className="flex-none">
            <div className="w-full lg:w-[250px]  sticky top-0">
              <div className="rounded-[10px] border border-[#A2A1A833]">
                <div
                  onClick={() => {
                    setActiveTab(1);
                  }}
                  className={`px-6 py-4 rounded-t-[10px] flex gap-3 items-center ${activeTab === 1
                    ? `text-[#fff] bg-[--theme] font-inter-semibold`
                    : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                    }`}
                >
                  <Icon
                    iconType={IconType.PROFILE_ICON}
                    color={activeTab === 1 ? "#fff" : undefined}
                  />
                  <span className="whitespace-nowrap">
                    {t('Customer Information')}
                  </span>
                </div>
                <div
                  onClick={() => {
                    setActiveTab(2);
                  }}
                  className={`px-6 py-4 rounded-b-[10px] flex gap-3 items-center ${activeTab === 2
                    ? `text-[#fff] bg-[--theme] font-inter-semibold`
                    : "text-primaryTextColor font-inter-light bg-white cursor-pointer"
                    }`}
                >
                  <Icon
                    iconType={IconType.PRODUCTS_ICON}
                    color={activeTab === 2 ? "#fff" : undefined}
                  />

                  <span>{t('Products')}</span>
                </div>
              </div>
              <ConditionalRender
                condition={relatedCustomers?.length <= 0 && activeTab === 1 && hasPermissionToEditRelationship}
              >
                <div className="mt-[60px]">
                  <h1 className="text-[#282D46] font-inter-bold">
                    {t('Related Customers')}
                  </h1>
                  <div>
                    <IconButton
                      className="!text-[--theme] bg-transparent border-none !p-0 !mt-[27px] sticky top-0"
                      secondary
                      onClick={() => {
                        setCurrentFormStep(3);
                      }}
                      icon={
                        <Icon
                          iconType={IconType.INCRASE_ICON}
                          color={themeColors.primary}
                        />
                      }
                    >
                      {t('')}
                    </IconButton>
                  </div>
                </div>
              </ConditionalRender>
            </div>
          </div> */}
          <div className="flex-1">
            <ConditionalRender condition={activeTab === 1}>
              <Form
                className="flex flex-col gap-5 mb-0"
                onSubmit={handleSubmit(onSubmit)}
              >
                {isCompany && (
                  <InputsFolder title={t('General Company Information')}>
                    <div className="pb-2">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <Input
                          label={t('Company Name')}
                          placeholder={t('Company Name')}
                          {...register("company_name")}
                          error={errors?.company_name}

                        />
                        <Input
                          label={t('Legal Form')}
                          placeholder={t('Legal Form')}
                          {...register("legal_form")}
                          error={errors?.legal_form}
                        />
                        <Input
                          label={t('UID Number')}
                          placeholder={t('UID Number')}
                          {...register("uid_number")}
                          error={errors?.uid_number}
                          type="number"
                        />
                        <Input
                          label={t('Industry')}
                          placeholder={t('Industry')}
                          {...register("industry")}
                          error={errors?.industry}
                        />
                        <div>
                          <Label>{t('Number of Employees')}</Label>
                          <div className="w-full">
                            <Controller
                              control={control}
                              name="number_of_employees"
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <CounterControl
                                  isInput
                                  count={value}
                                  className="!mt-0"
                                  classes={{
                                    container: "w-full bg-white !border-inputborder",
                                  }}
                                  onChange={(value: number) => onChange(value)}
                                  onIncrement={() => onChange(value + 1)}
                                  onDecrement={() =>
                                    onChange(value >= 1 ? value - 1 : value)
                                  }
                                />
                              )}
                            />
                          </div>
                        </div>
                        <Input
                          label={t('Website')}
                          placeholder={t('Website')}
                          {...register("website")}
                          error={errors?.website}
                        />
                        <Input
                          placeholder={t('General Email')}
                          label={t('General Email')}
                          {...register("company_email")}
                          error={errors?.company_email}
                        />

                        <div className="">
                          <Label>
                            {t('Phone Number')}
                          </Label>
                          <div className="grid grid-cols-[100px,auto] gap-[16px] items-end w-full">
                            <Controller
                              name="company_phone_code"
                              control={control}
                              defaultValue={defaultValue?.value}
                              render={({ field }) => (
                                <Creatable<any, false>
                                  {...field}
                                  options={numbersCode.map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                    icon: item.icon
                                  }))}
                                  value={
                                    field.value
                                      ? numbersCode?.find(item => item.value === field.value)
                                      : defaultValue || null
                                  }
                                  className="cursor-pointer font-inter-regular react-select-container"
                                  classNamePrefix="react-select"
                                  onChange={(newValue: any, actionMeta: any) => {
                                    if (
                                      actionMeta.action === "select-option" &&
                                      newValue?.value
                                    ) {
                                      field.onChange(newValue.value);
                                    }
                                  }}
                                  styles={customStyles}
                                  isValidNewOption={() => false}
                                  menuPosition={"fixed"}
                                  menuPortalTarget={document.body}
                                  formatOptionLabel={formatOptionLabel}
                                />
                              )}
                            />
                            <Input
                              placeholder={t('Enter phone number')}
                              {...register("company_phone")}
                              error={errors?.company_phone}
                              className="w-full"
                            />
                          </div>
                        </div>
                        <div className="relative">
                          <Label text={t('Preferred Language')} />
                          <Controller
                            name="prefered_language"
                            control={control}
                            rules={{ required: t("Language is required") }}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Choose language')}
                                options={languageData.map((language) => ({
                                  value: language.value,
                                  label: t(language.label),
                                }))}
                                value={
                                  field.value
                                    ? { value: field.value, label: t(languageData.find((lang) => lang.value === field.value)?.label as string) }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                              />
                            )}
                          />
                          {errors.prefered_language?.message && (
                            <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                              <>{t(errors.prefered_language?.message as string)}</>
                            </div>
                          )}
                        </div>
                        <Controller
                        control={control}
                        name="birthdate"
                        rules={{ required: t("Date of birth is required") }}
                        render={({ field: { onChange, value } }) => (
                          <PrimaryDatePicker
                            label={t('Date Of Founding')}
                            startDate={value}
                            {...register("birthdate")}
                            error={errors?.birthdate}
                            setStartDate={(date: string) => onChange(date)}
                          />
                        )}
                      />
                      </div>

                      {/* <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
                        {state.map((item: any) => {
                          if (item?.data?.section === "Personal information") {
                            extraFields[item?.data?.field_name] = {
                              value: watch(item?.data?.field_name),
                              default_text: item?.data?.default_text,
                            };

                            return (
                              <Input
                                label={item?.data?.field_name}
                                type={item?.data?.field_type === "text" ? "text" : "number"}
                                required={item?.data?.required}
                                placeholder={item?.data?.default_text}
                                {...register(item?.data?.field_name, { required: item?.data?.required ? t(`This field is required`) : false })}
                                error={errors?.[item?.data?.field_name]}
                              />
                            );
                          }
                          return null;
                        })}
                      </div> */}

                    </div>

                  </InputsFolder>
                )}

                <InputsFolder title={t(isCompany ? 'Primary Contact Person' : 'Personal information')}>
                  <div className="pb-2">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {isCompany && (
                        <div className="relative">
                          <Label text={t('Salutation')} />
                          <Controller
                            name="salutation"
                            control={control}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Salutation')}
                                options={[
                                  { label: t('Mr.'), value: 'Mr.' },
                                  { label: t('Mrs.'), value: 'Mrs.' },
                                  { label: t('Ms.'), value: 'Ms.' },
                                  { label: t('Dr.'), value: 'Dr.' },
                                  { label: t('Other'), value: 'Other' },
                                ]}

                                value={
                                  field.value
                                    ? { value: field.value, label: t(field.value) }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(
                                  newValue: any,
                                  actionMeta: any
                                ) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}

                              />
                            )}
                          />
                          {errors.salutation?.message && (
                            <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                              <>{t(errors.salutation?.message as string)}</>
                            </div>
                          )}
                        </div>
                      )}
                      <Input
                        label={t('First Name')}
                        placeholder={t('First Name')}
                        {...register("first_name")}
                        error={errors?.first_name}
                      />
                      <Input
                        label={t('Last Name')}
                        placeholder={t('Last Name')}
                        {...register("last_name")}
                        error={errors?.last_name}
                      />
                      {isCompany && (
                        <Input
                          label={t('Job Title')}
                          placeholder={t('Job Title')}
                          {...register("job_title")}
                          error={errors?.job_title}
                        />
                      )}
                      <div className="relative">
                        <Label text={t('Nationality')} />
                        <Controller
                          name="nationality"
                          control={control}
                          render={({ field }) => (
                            <Creatable<any, false>
                              {...field}
                              placeholder={t('Nationality')}
                              options={nationalities.map(nationality => {
                                return {
                                  label: t(nationality), value: nationality
                                }
                              })}

                              value={
                                field.value
                                  ? { value: field.value, label: t(field.value) }
                                  : null
                              }
                              className="cursor-pointer font-inter-regular react-select-container"
                              classNamePrefix="react-select"
                              onChange={(
                                newValue: any,
                                actionMeta: any
                              ) => {
                                if (
                                  actionMeta.action === "select-option" &&
                                  newValue?.value
                                ) {
                                  field.onChange(newValue.value);
                                }
                              }}
                              styles={customStyles}
                              isValidNewOption={() => false}
                              menuPosition={"fixed"}
                              menuPortalTarget={document.body}

                            />
                          )}
                        />
                        {errors.nationality?.message && (
                          <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                            <>{t(errors.nationality?.message as string)}</>
                          </div>
                        )}
                      </div>
                      {!isCompany && (
                      <Controller
                        control={control}
                        name="birthdate"
                        rules={{ required: t("Date of birth is required") }}
                        render={({ field: { onChange, value } }) => (
                          <PrimaryDatePicker
                            label={t('Date Of Birth')}
                            startDate={value}
                            {...register("birthdate")}
                            error={errors?.birthdate}
                            setStartDate={(date: string) => onChange(date)}
                          />
                        )}
                      />
                      )}
                      {!isCompany && (
                      <div className="relative">
                        <Label text={t('Language')} />
                        <Controller
                          name="language"
                          control={control}
                          rules={{ required: t("Language is required") }}
                          render={({ field }) => (
                            <Creatable<any, false>
                              {...field}
                              placeholder={t('Choose language')}
                              options={languageData.map((language) => ({
                                value: language.value,
                                label: t(language.label),
                              }))}
                              value={
                                field.value
                                  ? { value: field.value, label: t(languageData.find((lang) => lang.value === field.value)?.label as string) }
                                  : null
                              }
                              className="cursor-pointer font-inter-regular react-select-container"
                              classNamePrefix="react-select"
                              onChange={(newValue: any, actionMeta: any) => {
                                if (
                                  actionMeta.action === "select-option" &&
                                  newValue?.value
                                ) {
                                  field.onChange(newValue.value);
                                }
                              }}
                              styles={customStyles}
                              isValidNewOption={() => false}
                              menuPosition={"fixed"}
                              menuPortalTarget={document.body}
                            />
                          )}
                        />
                        {errors.language?.message && (
                          <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-20px]  left-[2px]">
                            <>{t(errors.language?.message as string)}</>
                          </div>
                        )}
                      </div>
                      )}
                      <div className="">
                        <Label>
                            {t('Phone Number')}
                          </Label>
                        <div className="grid grid-cols-[100px,auto] gap-[16px] items-end w-full">
                          <Controller
                            name="code"
                            control={control}
                            defaultValue={defaultValue?.value}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                options={numbersCode.map((item) => ({
                                  value: item.value,
                                  label: item.label,
                                  icon: item.icon
                                }))}
                                value={
                                  field.value
                                    ? numbersCode?.find(item => item.value === field.value)
                                    : defaultValue || null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                                formatOptionLabel={formatOptionLabel}
                              />
                            )}
                          />
                          <Input
                            placeholder={t('Enter phone number')}
                            {...register("phone")}
                            error={errors?.phone}
                            className="w-full"
                          />
                        </div>
                      </div>
                      <Input
                        placeholder={t('Enter email')}
                        label={t('Email')}
                        {...register("email")}
                        error={errors?.email}
                      />
                      {!isCompany && (
                        <div className="relative">
                          <Label text={t('Source')} />
                          <Controller
                            name="source"
                            control={control}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Choose source')}
                                options={[
                                  {
                                    value: "Recomandation",
                                    label: `${t('Recomandation')}`,
                                  }
                                ]}
                                value={
                                  field.value
                                    ? {
                                      value: field.value,
                                      label: t(field.value)
                                    }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                              />
                            )}
                          />

                        </div>
                      )}

                    </div>
                    
                    <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {state.map((item: any) => {
                        if (item?.data?.section === "Personal information") {
                          extraFields[item?.data?.field_name] = {
                            value: watch(item?.data?.field_name),
                            default_text: item?.data?.default_text,
                          };

                          return (
                            <Input
                              label={item?.data?.field_name}
                              type={item?.data?.field_type === "text" ? "text" : "number"}
                              required={item?.data?.required}
                              placeholder={item?.data?.default_text}
                              {...register(item?.data?.field_name, { required: item?.data?.required ? t(`This field is required`) : false })}
                              error={errors?.[item?.data?.field_name]}
                            />
                          );
                        }
                        return null;
                      })}
                    </div>

                  </div>

                </InputsFolder>

                <InputsFolder title={t('Address details')}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
                      <div className="grid grid-cols-2 gap-5">
                        <Input
                          placeholder={t('Enter street')}
                          label={t('Street')}
                          icon={IconType.LOCATION_ICON}
                          {...register("address")}
                          error={errors?.address}
                          classes={{ icon: "!bg-white right-[8px]" }}

                        />
                        <Input
                          placeholder={t('Enter Nr')}
                          label={t('Nr')}
                          {...register("nr")}
                          error={errors?.nr}

                        />
                        <div className="col-span-2">
                          <Controller
                            name="postal_code"
                            control={control}
                            rules={{ required: `${t('Postal code is required')}` }}
                            render={({ field }) => (
                              <div>
                                <Label>
                                  {t('PLZ')}
                                </Label>
                                <AutoCompletInput
                                  suggestions={flatData}
                                  value={field.value}
                                  setValue={(name, value) => {
                                    setLocationValue(value);
                                  }}
                                  keepValue={true}
                                  className="block"
                                  clearErrors={() => { clearErrors('postal_code'); clearErrors('city') }}
                                  placeholder={t('Enter PLZ')}
                                  onChange={(e) => field.onChange(e.target.value)}
                                  icon={IconType.LOCATION_ICON}
                                  error={errors?.postal_code}
                                  name="postal_code"

                                />
                              </div>
                            )}
                          />
                        </div>
                        <div className="col-span-2">
                          <Input
                            placeholder={t('Enter City')}
                            label={t('City')}
                            {...register("city")}
                            error={errors?.city}

                          />
                        </div>
                      </div>
                      <div>
                        <iframe
                          className="border-inputborder border rounded-[8px]"
                          title={t('map')}
                          src={`https://maps.google.com/maps?q='+${watch('postal_code')} ${watch('address')} ${watch('city')} ${watch('nr')}+'&t=&z=14&ie=UTF8&iwloc=&output=embed`}
                          style={{ width: "100%", height: "100%" }}
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>
                </InputsFolder>
                <ConditionalRender condition={relatedCustomers?.length >= 1}>
                  <InputsFolder title={t('Related Customers')}>
                    <div className="grid grid-cols-2 gap-5 items-center">
                      {relatedCustomers.map((customer, index) => (
                        <div key={index} className="mb-4">
                          <Input
                            label={t('Family member')}
                            type="text"
                            readOnly
                            disabled={true}
                            defaultValue={customer.name}
                          />
                        </div>
                      ))}
                      <Button
                        className="mt-3"
                        onClick={() => {
                          setRelatedCustomers([]);
                        }}
                      >
                        <Icon iconType={IconType.DELETE_ICON} color="#979797" />
                      </Button>
                    </div>
                  </InputsFolder>
                </ConditionalRender>
                <div
                  className={
                    hasPermissionToAssign
                      ? "grid gap-5 lg:grid-cols-2 sm:grid-cols-1"
                      : "gap-5 lg:grid-cols-1 lg:gap-0"
                  }
                >
                  <InputsFolder
                    title={t('Related details')}
                  >
                    <div>
                      <Label>{t('Note')}</Label>
                      <TextArea
                        {...register("note")}
                        rows={4}
                        className="resize-none border-[1px] border-inputborder rounded-[8px] w-full p-[7px] 2xl:p-[10px] outline-0 indent-2 placeholder-[#667085] font-inter-regular"
                        placeholder={t('Write note')}
                        error={errors?.note}
                      />
                      <div className="pt-5">
                        {state.map((item: any) => {
                          if (item?.data?.section === "Related details") {
                            extraFields[item?.data?.field_name] = {
                              value: watch(item?.data?.field_name),
                              default_text: item?.data?.default_text,
                            };
                            return (
                              <Input
                                label={item?.data?.field_name}
                                type={item?.data?.field_type === "text" ? "text" : "number"}
                                required={item?.data?.required}
                                placeholder={item?.data?.default_text}
                                {...register(item?.data?.field_name, { required: item?.data?.required ? t(`This field is required`) : false })}
                                error={errors?.[item?.data?.field_name]}
                              />
                            );
                          }
                          return null;
                        })}
                      </div>
                    </div>

                  </InputsFolder>

                  <ConditionalRender condition={hasPermissionToAssign}>
                    <InputsFolder
                      title={t('Assignement')}
                      childrenClassName="max-h-[180px] h-full rounded-l-none"
                    >
                      <div>
                        <div>
                          <Label>{t('Worker')}</Label>
                        </div>
                        <div>
                          <Controller
                            name="from_user"
                            control={control}
                            render={({ field }) => (
                              <Creatable<any, false>
                                {...field}
                                placeholder={t('Choose Worker')}
                                options={fetchedUsers?.map?.((source: any) => ({
                                  label: `${source.name ?? ''} ${source.last_name ?? ''}`,
                                  value: source.id,
                                }))}
                                value={
                                  field?.value
                                    ? {
                                      value: field?.value,
                                      label:
                                        (
                                          fetchedUsers?.find?.(
                                            (item: any) =>
                                              item.id === field.value
                                          ) as { name: string } | undefined
                                        )?.name || field.value,
                                    }
                                    : null
                                }
                                className="cursor-pointer font-inter-regular react-select-container"
                                classNamePrefix="react-select"
                                onChange={(newValue: any, actionMeta: any) => {
                                  if (
                                    actionMeta.action === "select-option" &&
                                    newValue?.value
                                  ) {
                                    field.onChange(newValue.value);
                                  }
                                }}
                                styles={customStyles}
                                isValidNewOption={() => false}
                                menuPosition={"fixed"}
                                menuPortalTarget={document.body}
                              />
                            )}
                          />
                        </div>
                        <div className="flex flex-col gap-[15px] 2xl:gap-[24px]"></div>
                      </div>
                    </InputsFolder>
                  </ConditionalRender>


                </div>
                <div className="pt-5 space-y-5">
                  {state.map((item: any) => {
                    extraFields[item?.data?.field_name] = {
                      value: watch(item?.data?.field_name),
                      default_text: item?.data?.default_text,
                    };
                    return item?.data?.section !== "Personal information" &&
                      item?.data?.section !== "Related details" ? (
                      <InputsFolder title={item?.data?.section}>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                          <Input
                            label={item?.data?.field_name}
                            type={item?.data?.field_type === "text" ? "text" : "number"}
                            required={item?.data?.required}
                            placeholder={item?.data?.default_text}
                            {...register(item?.data?.field_name, { required: item?.data?.required ? t(`This field is required`) : false })}
                            error={errors?.[item?.data?.field_name]}
                          />
                        </div>
                      </InputsFolder>
                    ) : null;
                  })}
                </div>
                <div className="flex items-center justify-end gap-[26px] mt-[40px]">
                  <Button
                    onClick={() => {
                      setIsAddNewFieldModalOpen(true);
                    }}
                    type="button"
                    className={`bg-transparent flex items-center gap-2 font-inter-medium text-[14px] text-[--theme]`}
                  >
                    <Icon iconType={IconType.PLUS_ICON} color={themeColors.primary} />
                    {t('Add Field')}
                  </Button>
                  <IconButton
                    className="flex justify-end  lg:mt-0 whitespace-nowrap"
                  >
                    {t('Next Step')}
                  </IconButton>
                </div>
              </Form>
            </ConditionalRender>
            <ConditionalRender condition={activeTab === 2}>
              <ChooseProducts
                data={formData.products as any[]}
                setFormStep={setCurrentFormStep}
                setFormData={setFormData}
                onSubmitFormData={onSubmitFormData}
                themeColors={themeColors}
                create={create}
                onConfirm={onConfirm}
                productsFormData={productsFormData}
              />
            </ConditionalRender>
          </div>
        </div>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 2}>
        <Form
          onSubmit={handleSubmitExtraField(onSubmitExtraFields)}
          className="pt-[30px]"
        >
          <div className="w-full pb-5">
            <Label>
              {t("Art of Application")}
            </Label>
            <div className="flex gap-4 relative">
              <div className="flex-1">
                <RadioButton
                  label={t('Online Application')}
                  isChecked={formData.art_of_application === 'Online Application'}
                  value={'Online Application'}
                  onChange={() => setFormData({
                    ...formData,
                    art_of_application: 'Online Application'
                  })}
                  labelClassName="h-[44px] items-center flex bg-white"
                  iconWrapperClassName="!top-[21px] !right-[6px]"
                  className="right-[8px]"
                  name={`art_of_application`}
                />

              </div>
              <div className="flex-1">
                <RadioButton
                  label={t('Paper Application')}
                  value={'Paper Application'}
                  isChecked={formData.art_of_application === 'Paper Application'}
                  onChange={() => setFormData({
                    ...formData,
                    art_of_application: 'Paper Application'
                  })}
                  labelClassName="h-[44px] items-center flex bg-white"
                  iconWrapperClassName="!top-[21px] !right-[6px]"
                  className="right-[8px]"
                  name={`art_of_application`}
                />
              </div>
              {/* {extraFieldErrors?.art_of_application && (
                <div className="font-inter-regular text-xs text-red-600 w-max absolute bottom-[-16px] 2xl:bottom-[-18px]  left-[2px]">
                  {extraFieldErrors?.art_of_application.message as any}
                </div>
              )} */}
            </div>
          </div>
          <div className="flex gap-x-4 relative w-full flex-wrap mb-5">
            <div className="w-full">
              <Label>{t("Mandate contract")}? </Label>
            </div>
            <div className="flex-1">

              <RadioButton
                label={t('Yes')}
                isChecked={formData.mandated === 1}
                onChange={() => setFormData({
                  ...formData,
                  mandated: 1
                })}
                value={1}
                labelClassName="h-[44px] items-center flex bg-white"
                iconWrapperClassName="!top-[21px] !right-[6px]"
                className="right-[8px]"
                name={`mandated`}

              />

            </div>
            <div className="flex-1">

              <RadioButton
                label={t('No')}
                value={0}
                isChecked={formData.mandated === 0}
                onChange={() => setFormData({
                  ...formData,
                  mandated: 0
                })}
                labelClassName="h-[44px] items-center flex bg-white"
                iconWrapperClassName="!top-[21px] !right-[6px]"
                className="right-[8px]"
                name={`mandated`}

              />

            </div>

          </div>
          {optionsByCheckbox.map(({ checkboxValue, customOptions, id }: any) => (
            <div key={id} className="flex items-center gap-4 mb-3">
              <div className="basis-1/3 flex items-center gap-4">
                <Checkbox
                  value={checkboxValue}
                  isChecked={
                    formData[id] && formData[id].checked
                      ? formData[id].checked
                      : false
                  }
                  onChange={(e) =>
                    handleCheckboxChange(id, e.target.checked)
                  }
                />
                <Label className="capitalize !mb-0">{t(checkboxValue)}</Label>
              </div>
              <div className="flex-1">
                <Controller
                  name="Company"
                  control={control}
                  render={({ field }) => (
                    <Creatable<any, false>
                      {...field}
                      options={customOptions}
                      value={field.value}
                      className="cursor-pointer font-inter-regular react-select-container"
                      classNamePrefix="react-select"
                      onChange={(selectedOption) => {
                        handleSelectChange(id, selectedOption ? selectedOption.value : null)
                        setPartnerParams({
                          base_product: checkboxValue,
                          partner_id: optionsByCheckbox.filter(
                            (option: any) => option.checkboxValue === checkboxValue)[0]
                            ?.customOptions?.find((option: any) => option.value === selectedOption?.value
                            )?.id
                        })
                        setLastChangedSelectId(id);
                      }
                      }
                      styles={customStyles}
                      placeholder={t('Choose Company')}
                      isValidNewOption={() => false}
                      menuPosition={"fixed"}
                      menuPortalTarget={document.body}
                      isDisabled={!formData[id]?.checked}
                    />
                  )}
                />
              </div>
              <div className="flex-1">

                <Controller
                  control={control}
                  name={`product.${id}`}
                  render={({ field }) => (
                    <Creatable<any, false>
                      {...field}
                      placeholder={t('Choose Product')}
                      options={PartnerProductsState[checkboxValue]?.map?.((product: any) => ({
                        label: product?.product,
                        value: product?.product,
                      }))}

                      value={
                        field.value
                          ? { value: field.value, label: field.value }
                          : null
                      }
                      isDisabled={isLoading}
                      className="cursor-pointer !w-full font-inter-regular react-select-container"
                      classNamePrefix="react-select !w-full"
                      onChange={(newValue: any, actionMeta: any) => {
                        if (actionMeta.action === "select-option" && newValue?.value) {
                          handleProductChange(id, newValue.value)
                          field.onChange(newValue.value);
                        }
                      }}
                      styles={customStyles}
                      isValidNewOption={() => false}
                      menuPosition={"fixed"}
                      menuPortalTarget={document.body}
                    />
                  )}
                />
              </div>
              {id < 7 ? (

                <div className="cursor-pointer w-[20px] flex justify-center flex-none" onClick={() => { addNewOption(checkboxValue) }}>
                  <Icon iconType={IconType.PLUS_ICON} color="#7D8592" />
                </div>
              ) : (
                <div className="cursor-pointer" onClick={() => { removeOption(id) }}>
                  <Icon iconType={IconType.DELETE_ICON} />
                </div>
              )}
            </div>
          ))}
          <IconButton
            type="submit"
            className="max-w-[200px] mt-[30px]  flex justify-end ml-auto"
          >
            {t('Add Product')}
          </IconButton>
        </Form>
      </ConditionalRender>
      <ConditionalRender condition={currentStep === 3}>
        <RelatedCustomerForm
          onAddCustomer={handleAddCustomer}
          setCurrentStep={setCurrentFormStep}
        />
      </ConditionalRender>

      <AddNewField
        hocTitle="Create New Field"
        setExtraFields={setState}
        extraFields={state}
        hocisOpen={IsAddNewFieldModalOpen}
        hocToggleModal={() => setIsAddNewFieldModalOpen(false)}
        hocCurrentStep={1}
        hocClasses={{
          modalClassName: 'max-w-[500px] w-full'
        }}
      />
    </div>
  );
};

export default withModal(CreateCustomerProcces);
